var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width })},_vm._l((_vm.lines),function(line,index){return _c('p',{key:index,class:[`${_vm.carbonPrefix}--skeleton__text`, { [`${_vm.carbonPrefix}--skeleton__heading`]: _vm.heading }],style:({ width: line.width })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }